// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function CatalogProductNameTableCell(props) {
  let __openNewTab = props.openNewTab;
  let shopName = props.shopName;
  let openNewTab = __openNewTab !== undefined ? __openNewTab : false;
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextLink.make, {
          text: I18n.t(props.name),
          to: {
            TAG: "Route",
            _0: CatalogRoutes.variantRoute(props.cku)
          },
          openNewTab: openNewTab
        }),
        shopName !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: shopName,
            variation: "normal",
            size: "xxsmall"
          }) : null
      ],
      space: Stdlib_Option.isSome(shopName) ? "xxsmall" : "none"
    }),
    spaceY: "xsmall",
    spaceRight: "normal"
  });
}

let make = React.memo(CatalogProductNameTableCell);

export {
  make,
}
/* make Not a pure module */
